import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { AuthService } from "src/app/service/auth.service";
import { AppURL } from "../app.url";

/** ตรวจสอบว่ามีการยืนยันตัวตนแล้วหรือยัง */
export const AuthGuard: CanActivateFn | CanActivateChildFn = async (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const redirect = router.createUrlTree(['', AppURL.account, { redirect: state.url }]);
    return auth.authorization()
        .then(status => status ? true : redirect)
        .catch(() => redirect);
}